import {useMedia} from 'react-use';

export const useIsPortrait = () => {
    return useMedia('(orientation: portrait)');
};
